import type { ReactNode } from 'react';

interface Props {
  icon: string;
  message: string;
  action?: ReactNode;
}

export function EmptyState({ icon, message, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
      <span className="text-4xl">{icon}</span>
      <p className="text-sm text-text-secondary">{message}</p>
      {action}
    </div>
  );
}
